module.exports = __webpack_public_path__ + "dist/img/carsaver-logo.b629da01.png";